import React, { useState, useEffect } from 'react';
import { Box, Heading, Text, Flex } from '@chakra-ui/react';
//import { Doughnut } from 'react-chartjs-2'; #needs to be added to package.json when we use it 
import useServerApi from 'hooks/useServerApi';


const AgentAnalytics = ({ startTimestamp, endTimestamp }) => {

    /*const dateRanges = [
        { label: '7d', value: '7d' },
        { label: '2w', value: '2w' },
        { label: '1m', value: '1m' },
        { label: '2m', value: '2m' },
        { label: '1y', value: '1y' },
    ];*/

    const parseDuration = (duration) => {
        if (typeof duration === 'string') {
            const parts = duration.split(':');
            if (parts.length === 2) {
                const mins = parseInt(parts[0], 10);
                const secs = parseInt(parts[1], 10);
                return mins * 60 + secs;
            }
        }
        return parseInt(duration, 10) || 0;
    };

    const formatDuration = (seconds) => {
        if (!seconds) return '0s';
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}m ${secs}s`;
    };
    const [{ post }] = useServerApi();
    const [analytics, setAnalytics] = useState({ transferred_calls: 0, booked_events: 0, calls_answered: 0, average_duration: 0, is_transfer_enabled: false, is_calendar_enabled: false });


    // Helper to calculate start_date and end_date from selectedRange or props
    const getDateRange = () => {
        if (startTimestamp && endTimestamp) {
            console.log('Using both provided timestamps:', startTimestamp, endTimestamp);
            // If timestamps are provided, use them
            const format = (ts) => new Date(ts).toISOString();
            return { start_date: format(startTimestamp), end_date: format(endTimestamp) };
        }
        let startDate = new Date();
        let endDate = new Date();
        try {
            startDate.setDate(endDate.getDate() - 7);
            if (startTimestamp) {
                startDate = new Date(startTimestamp);
            }
        } catch (error) {
            console.error('Error parsing startTimestamp:', error);
        }
        const format = (d) => d.toISOString();
        return { start_date: format(startDate), end_date: format(endDate) };
    };




    useEffect(() => {
        const fetchAnalytics = async () => {
            try {
                const { start_date } = getDateRange();
                const [success, response] = await post('/rest_endpoints/agents/crud/analytics', { start_date });
                if (success && response) {
                    setAnalytics({
                        transferred_calls: response.transferred_calls || 0,
                        booked_events: response.booked_events || 0,
                        calls_answered: response.calls_answered || 0,
                        average_duration: parseDuration(response.average_duration) || 0,
                        is_transfer_enabled: response.is_transfer_enabled || false,
                        is_calendar_enabled: response.is_calendar_enabled || false,
                    });
                }
            } catch (error) {
                // Optionally handle error
            } finally {

            }
        };
        fetchAnalytics();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startTimestamp, endTimestamp, post]);


    return (
        <Box my={8} p={6} bg="white" borderRadius="lg" boxShadow="md">
            <Heading size="md" mb={4} color="gray.700">
                Agent Analytics
            </Heading>
            {/* Date Range Selector 
            <Flex mb={6} align="center" justify="space-between" flexWrap="wrap">
                <Text fontWeight="bold" color="gray.600" mr={4}>
                    Date Range:
                </Text>
                <ButtonGroup isAttached variant="outline" colorScheme="teal">
                    {dateRanges.map((range) => (
                        <Button
                            key={range.value}
                            onClick={() => handleRangeChange(range.value)}
                            isActive={selectedRange === range.value}
                        >
                            {range.label}
                        </Button>
                    ))}
                </ButtonGroup>
            </Flex>*/}
            {/* Summary Section */}
            <Flex mb={6} gap={4} justify="space-between" flexWrap="wrap">
                <Box flex="1" minW="150px" bg="gray.50" p={4} borderRadius="md" textAlign="center" boxShadow="sm">
                    <Text fontSize="sm" color="orange.600" fontWeight="bold" mb={1}>
                        <span role="img" aria-label="Calls Answered">📞</span> Calls Answered
                    </Text>
                    <Text fontSize="2xl" color="orange.700" fontWeight="bold">{analytics.calls_answered}</Text>
                </Box>
                <Box flex="1" minW="150px" bg="gray.50" p={4} borderRadius="md" textAlign="center" boxShadow="sm">
                    <Text fontSize="sm" color="purple.600" fontWeight="bold" mb={1}>
                        <span role="img" aria-label="Average Duration">⏱️</span> Avg Duration
                    </Text>
                    <Text fontSize="2xl" color="purple.700" fontWeight="bold">{formatDuration(analytics.average_duration)}</Text>
                </Box>
                {analytics.is_transfer_enabled && (
                    <Box flex="1" minW="150px" bg="gray.50" p={4} borderRadius="md" textAlign="center" boxShadow="sm">
                        <Text fontSize="sm" color="blue.600" fontWeight="bold" mb={1}>
                            <span role="img" aria-label="Transferred Calls">🔄</span> Transferred Calls
                        </Text>
                        <Text fontSize="2xl" color="blue.700" fontWeight="bold">{analytics.transferred_calls}</Text>
                    </Box>
                )}
                {analytics.is_calendar_enabled && (
                    <Box flex="1" minW="150px" bg="gray.50" p={4} borderRadius="md" textAlign="center" boxShadow="sm">
                        <Text fontSize="sm" color="green.600" fontWeight="bold" mb={1}>
                            <span role="img" aria-label="Booked Events">📅</span> Booked Events
                        </Text>
                        <Text fontSize="2xl" color="green.700" fontWeight="bold">{analytics.booked_events}</Text>
                    </Box>
                )}
            </Flex>

            {/* Donut Chart: show only if at least one is enabled */}

        </Box>
    );
};

export default AgentAnalytics;
